import React from 'react';
import { ECampaignStatusChangeReason } from 'types/campaign';

import { ButtonBase } from '@material-ui/core';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';
import PaymentIcon from '@material-ui/icons/Payment';

import CampaignResumeAction from 'components/CampaignResumeAction/CampaignResumeAction';
import DashboardBubble from 'components/DashboardBubble/DashboardBubble';

const CampaignPausedStatusBubble = ({
  campaign,
  isAnyAgent,
  mutateCampaign,
  onViewBilling,
  rootClass,
}) => {
  if (campaign.pauseReason === ECampaignStatusChangeReason.PausedPaymentFailed) {
    return (
      <DashboardBubble
        variant="status"
        tone="warning"
        rootClass={rootClass}
        icon={<PaymentIcon />}
        title="Payment required"
        content="This campaign is paused because a payment failed. It will resume automatically after the payment succeeds."
        action={isAnyAgent && onViewBilling ? (
          <ButtonBase onClick={onViewBilling}>
            View billing
          </ButtonBase>
        ) : undefined}
      />
    );
  }

  if (campaign.pauseReason === ECampaignStatusChangeReason.PausedManually) {
    return (
      <DashboardBubble
        variant="status"
        tone="neutral"
        rootClass={rootClass}
        icon={<PauseCircleOutlineIcon />}
        title="Campaign paused"
        content="Marketing touches will not be sent until this campaign is resumed."
        action={(
          <CampaignResumeAction campaign={campaign} mutateCampaign={mutateCampaign}>
            <ButtonBase>
              Resume campaign
            </ButtonBase>
          </CampaignResumeAction>
        )}
      />
    );
  }

  return (
    <DashboardBubble
      variant="status"
      tone="neutral"
      rootClass={rootClass}
      icon={<PauseCircleOutlineIcon />}
      title="Campaign paused"
      content="Marketing touches are paused. Please contact support if you need help resuming this campaign."
    />
  );
};

export default CampaignPausedStatusBubble;
